import React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';

const useFooterStyles = makeStyles({
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 32px',
        backgroundColor: tokens.colorNeutralBackground3,
        borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
        flexShrink: 0,
    },
    link: {
        color: tokens.colorBrandForegroundLink,
        textDecoration: 'underline',
        fontSize: tokens.fontSizeBase200,
        fontWeight: tokens.fontWeightRegular,
        '&:hover': {
            textDecoration: 'underline',
        },
        '&:focus-visible': {
            outline: `2px solid ${tokens.colorBrandStroke1}`,
            outlineOffset: '2px',
            borderRadius: tokens.borderRadiusSmall,
        },
    },
    copyright: {
        color: tokens.colorNeutralForeground3,
        fontSize: tokens.fontSizeBase200,
        fontWeight: tokens.fontWeightRegular,
    },
});

export const Footer: React.FC = () => {
    const styles = useFooterStyles();

    return (
        <footer className={styles.footer} role="contentinfo">
            <a
                href="https://www.microsoft.com/en-us/privacy/data-privacy-notice"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
                aria-label="Microsoft data privacy notice (opens in a new tab)"
            >
                Microsoft data privacy notice
            </a>
            <span className={styles.copyright}>©2026 Microsoft</span>
        </footer>
    );
};
